// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"452":"c8cfbb52e3d4b66a","756":"4125ab039ce73545"}[chunkId] + ".js";
};